/**
 * FctHeader — cabecera corporativa con logo y línea de acento verde.
 *
 * Sigue el patrón visual de farmaconsulting.es: fondo blanco, logo a la
 * izquierda, navegación o controles a la derecha, y un borde inferior
 * con el verde corporativo para reforzar identidad.
 */

import React from 'react';
import { Layout } from 'antd';
import { fctColors, fctLogoUrls } from '../../theme/theme';

const { Header } = Layout;

interface FctHeaderProps {
  /**
   * URL del logo a mostrar. Por defecto usa el logo institucional de la web
   * corporativa. Si la app es interna y no requiere branding "35 aniversario",
   * conviene pasar otra URL o el logo sin pie.
   */
  logoSrc?: string;
  /**
   * Altura del logo en píxeles. El Header tiene 72px, así que 48 deja
   * buen margen visual.
   */
  logoHeight?: number;
  /**
   * Texto opcional junto al logo (por ejemplo, el nombre de la app interna).
   */
  appName?: string;
  /**
   * Contenido a renderizar a la derecha del header (menú, avatar, etc.).
   */
  rightContent?: React.ReactNode;
}

export const FctHeader: React.FC<FctHeaderProps> = ({
  logoSrc = fctLogoUrls.logoVertical35,
  logoHeight = 48,
  appName,
  rightContent,
}) => {
  return (
    <Header
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: `3px solid ${fctColors.verdeCorporativo}`,
        boxShadow: '0 1px 4px rgba(0, 0, 0, 0.06)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <img
          src={logoSrc}
          alt="Farmaconsulting Transacciones"
          style={{ height: logoHeight, width: 'auto' }}
        />
        {appName && (
          <span
            style={{
              fontSize: 18,
              fontWeight: 500,
              color: fctColors.negroCorporativo,
              borderLeft: `1px solid ${fctColors.grisBorde}`,
              paddingLeft: 16,
            }}
          >
            {appName}
          </span>
        )}
      </div>
      {rightContent && <div>{rightContent}</div>}
    </Header>
  );
};
